import React, { Component } from 'react'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import TimeField from 'vendor/time-field'

export default class TimeInput extends Component {
	UNSAFE_componentWillMount = _ => {
		
	}

	render() {
		const {
			string,
			unit,
			isEdit,
			handleChange
		} = this.props

		return (
			<div className="time-container">
				<div className="time-field-container">
					<TimeField
						onChange={value => handleChange('text', value)}
						value={string}
						disabled={!isEdit}
						placeholder={'12:00'}
						//onKeyPress={e => {(e.key === 'Enter') ? this.saveSession(session) : null }}
						colon=":"
					/>
				</div>
				<DropdownMenu 
					isObjects={true} 
					selectableItems={[
						{
							id: 1,
							name: 'am'
						},{
							id: 2,
							name: 'pm'
						}
					]} 
					selectedItemId={unit} 
					handleChange={value => handleChange('unit', value)} 
					parentType="unit" 
				/>
			</div>
		)
	}
}
